import { render, staticRenderFns } from "./ContactSupportIcon.vue?vue&type=template&id=ab6f5b8e&scoped=true"
import script from "./ContactSupportIcon.vue?vue&type=script&lang=js"
export * from "./ContactSupportIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6f5b8e",
  null
  
)

export default component.exports